import type { ModuleTagEntry } from './index';

/** Patient module tags. */
export const tags: ModuleTagEntry[] = [
  'PatientID',
  'PatientName',
  'PatientBirthDate',
  'PatientBirthTime',
];
